/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CombineDocuments200ResponseData
 */
export interface CombineDocuments200ResponseData {
    /**
     * The ID of the retained lead
     * @type {string}
     * @memberof CombineDocuments200ResponseData
     */
    retained_lead_id: string;
    /**
     * Number of documents moved to the retained lead
     * @type {number}
     * @memberof CombineDocuments200ResponseData
     */
    documents_moved_count: number;
    /**
     * Number of leads cancelled
     * @type {number}
     * @memberof CombineDocuments200ResponseData
     */
    leads_cancelled_count: number;
}

/**
 * Check if a given object implements the CombineDocuments200ResponseData interface.
 */
export function instanceOfCombineDocuments200ResponseData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "retained_lead_id" in value;
    isInstance = isInstance && "documents_moved_count" in value;
    isInstance = isInstance && "leads_cancelled_count" in value;

    return isInstance;
}

export function CombineDocuments200ResponseDataFromJSON(json: any): CombineDocuments200ResponseData {
    return CombineDocuments200ResponseDataFromJSONTyped(json, false);
}

export function CombineDocuments200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CombineDocuments200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'retained_lead_id': json['retained_lead_id'],
        'documents_moved_count': json['documents_moved_count'],
        'leads_cancelled_count': json['leads_cancelled_count'],
    };
}

export function CombineDocuments200ResponseDataToJSON(value?: CombineDocuments200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'retained_lead_id': value.retained_lead_id,
        'documents_moved_count': value.documents_moved_count,
        'leads_cancelled_count': value.leads_cancelled_count,
    };
}

